export const ATTENDANCE_REQUEST = "ATTENDANCE_REQUEST";
export const ATTENDANCE_SUCCESS = "ATTENDANCE_SUCCESS";
export const ATTENDANCE_FAIL = "ATTENDANCE_FAIL";
